import { render, staticRenderFns } from "./ShaparakMerchants.vue?vue&type=template&id=b788c5bc"
import script from "./ShaparakMerchants.vue?vue&type=script&lang=js"
export * from "./ShaparakMerchants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports